module.exports = __webpack_public_path__ + "img/clapperboard-play.2d6efe36.svg";